var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResendInvitedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1679 4.46967C17.875 4.17678 17.4001 4.17678 17.1072 4.46967C16.8143 4.76256 16.8143 5.23744 17.1072 5.53033L17.8269 6.25H10.6375C8.01419 6.25 5.88754 8.37665 5.88754 11V12C5.88754 12.4142 6.22333 12.75 6.63754 12.75C7.05176 12.75 7.38754 12.4142 7.38754 12V11C7.38754 9.20507 8.84262 7.75 10.6375 7.75H17.8269L17.1072 8.46967C16.8143 8.76256 16.8143 9.23744 17.1072 9.53033C17.4001 9.82322 17.875 9.82322 18.1679 9.53033L19.4608 8.23744C20.1442 7.55402 20.1442 6.44598 19.4608 5.76256L18.1679 4.46967ZM7.10721 19.5303C7.40011 19.8232 7.87498 19.8232 8.16787 19.5303C8.46077 19.2374 8.46077 18.7626 8.16787 18.4697L7.4482 17.75H14.6375C17.2609 17.75 19.3875 15.6234 19.3875 13V12C19.3875 11.5858 19.0518 11.25 18.6375 11.25C18.2233 11.25 17.8875 11.5858 17.8875 12V13C17.8875 14.7949 16.4325 16.25 14.6375 16.25H7.4482L8.16787 15.5303C8.46077 15.2374 8.46077 14.7626 8.16787 14.4697C7.87498 14.1768 7.40011 14.1768 7.10721 14.4697L5.81432 15.7626C5.1309 16.446 5.1309 17.554 5.81432 18.2374L7.10721 19.5303Z",
    fill: "#1373E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendInvitedIcon);
export default __webpack_public_path__ + "static/media/resend_invited_icon.50a07cf5d13bafc3bd0fbae002de413a.svg";
export { ForwardRef as ReactComponent };